/* eslint-disable no-undef */
import { Icustomers } from "types/customers.type";
import api from "./ApiService";

const getCustomers = (data?: any) => {
  return api
    .get<Icustomers>(process.env.REACT_APP_API_BASE_URL + `/customers?${data}`)
    .then((response: any) => {
      return response;
    });
};

const getCustomerApplications = (customerId: number, applicationId: number) => {
  return api
    .get<any>(
      process.env.REACT_APP_API_BASE_URL +
        `/customer-applications?CustomerId=${customerId}&ApplicationId=${applicationId}`
    )
    .then((response: any) => {
      return response;
    });
};

const saveCustomerApplication = (id: number, payload: any) => {
  return api
    .put<any>(
      process.env.REACT_APP_API_BASE_URL + `/customer-applications/${id}`,
      payload
    )
    .then((response: any) => {
      return response;
    });
};

const CustomerService = {
  getCustomers,
  getCustomerApplications,
  saveCustomerApplication,
};
export default CustomerService;
